import { render, staticRenderFns } from "./validate_multi_sn_warranty.vue?vue&type=template&id=20876308&"
import script from "./validate_multi_sn_warranty.vue?vue&type=script&lang=js&"
export * from "./validate_multi_sn_warranty.vue?vue&type=script&lang=js&"
import style0 from "./validate_multi_sn_warranty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports